// Validates hook form radio buttons when no option is selected by default
const validateNullRadio = value => {
  if (value === null) {
    return 'Please select an option';
  }

  return true;
};

export default validateNullRadio;
